import { Loadable } from 'utils/components';

export default {
  path: `invitations/:id`,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'CompletePage' */ './components/InvitationPage')
  })
};
